import { useFeatureGate } from '@statsig/react-bindings';
import { useCallback } from 'react';

import { Statsig } from '../statsig/StatsigProvider';
import { telehealthManualAdmissionFlowGate } from '../statsig/gates';
import { AdmissionFlow } from '../types';
import { VideoPlatform } from '../video-sdk';
import {
  useGetVideoPlatformOfAdmittedRoomCallback,
  useVideoPlatformOfAdmittedRoom,
} from '../visitor/waiting-room/admission/useVideoPlatformOfAdmittedRoom';

function getAdmissionFlow(videoPlatform: VideoPlatform | null, isManualAdmissionFlowEnabled: boolean): AdmissionFlow {
  return videoPlatform === VideoPlatform.Zoom && isManualAdmissionFlowEnabled ? 'manual' : 'auto';
}

/**
 * The client user checks this gate and relays their admission flow to the
 * provider side as part of their presence updates.
 *
 * Defaults to auto admission flow.
 */
export function useAdmissionFlow(): AdmissionFlow {
  const { value: isManualAdmissionFlowEnabled } = useFeatureGate(telehealthManualAdmissionFlowGate);
  const videoPlatformOfAdmittedRoom = useVideoPlatformOfAdmittedRoom();

  return getAdmissionFlow(videoPlatformOfAdmittedRoom, isManualAdmissionFlowEnabled);
}

export function useAdmissionFlowCallback(): () => AdmissionFlow {
  const getVideoPlatformOfAdmittedRoom = useGetVideoPlatformOfAdmittedRoomCallback();

  return useCallback(() => {
    return getAdmissionFlow(getVideoPlatformOfAdmittedRoom(), Statsig.checkGate(telehealthManualAdmissionFlowGate));
  }, [getVideoPlatformOfAdmittedRoom]);
}
